import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=5d0e8e26&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"
import style0 from "./Index.vue?vue&type=style&index=0&id=5d0e8e26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@corefy+vue2-vue-template-compiler@2.7.24_css-loader@6.8.1_webpack@5_7038a5b31aeda1c26d50c85a281906e5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0e8e26",
  null
  
)

export default component.exports